module.exports = __webpack_public_path__ + "media/images/ic-whatsapp-7a085926c350e95286e5185c8f1ddf34.svg";